<style scoped>
   .section-block {
      margin-bottom: 1.5rem;
   }

   .section-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 1rem;
      padding-bottom: 0.75rem;
      border-bottom: 1px solid #e5e7eb;
   }

   .section-title {
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      color: #111;
   }

   .section-sub {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
   }
</style>

<template>
    <div class="">
		<app-overlay-loader v-if="preloader" />
			<form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <br>
                    <div class="section-block">
                        <div class="section-header">
                            <div>
                                <h3 class="section-title">Supplier & Shipment Route</h3>
                                <p class="section-sub">Select supplier and configure origin, destination and addresses</p>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Address selector -->
                            <div class="col-md-6">
                                <AddressRequired v-model="inputs.sd_selectedOption" :read="is_view" :num="4"/>
                            </div>

                            <!-- Ship from/to -->
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_ship" :is_view="is_view" :list="from_to_list" label="Ship from/to" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>

                            <!-- Supplier -->
                            <div class="col-md-6">
                                <SelectHttp v-model="inputs.sd_supplier" @input="validateSupplier" :is_view="is_view || isFromCost" label="Supplier" :required="true" url="/companies_supplier/serverside/selectable-name" listValueField="Title" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionSupplier" :read="is_view" />
                            </div>

                            <!-- Ship Address A -->
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_ship_address" :is_view="is_view" :list="ship_address_list" label="Ship Address (A)" :required="!toggle_validation" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionSupplierShipAddress" :read="is_view" />
                            </div>

                            <!-- Ship Address B -->
                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 2">
                                <SelectCustom v-model="inputs.sd_ship_address_2" :is_view="is_view" :list="ship_address_list" label="Ship Address (B, optional)" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionShipAddress2" :read="is_view" />
                            </div>

                            <!-- Ship Address C -->
                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 3">
                                <SelectCustom v-model="inputs.sd_ship_address_3" :is_view="is_view" :list="ship_address_list" label="Ship Address (C, optional)" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionShipAddress3" :read="is_view" />
                            </div>

                            <!-- Ship Address D -->
                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 4">
                                <SelectCustom v-model="inputs.sd_ship_address_4" :is_view="is_view" :list="ship_address_list" label="Ship Address (D, optional)" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionShipAddress4" :read="is_view" />
                            </div>
                        </div>
                        <div class="row">    
                            <!-- Ship final dest -->
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_finalDest" :is_view="is_view" :list="ship_final_destination_list" label="Ship final dest" divGridClass="col-sm-12" />
                            </div>

                            <!-- Final destination -->
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_finalDestination" :is_view="is_view" :list="ship_address_list" label="Final destination" divGridClass="col-sm-12" />
                                <DescriptionAddress v-model="inputs.sd_descriptionFinalDestination" :read="is_view" />
                            </div>
                        </div>
                    </div>

                    <div class="section-block">
                        <div class="section-header">
                            <div>
                                <h3 class="section-title">Shipment Dates & Details</h3>
                                <p class="section-sub">Define shipment period and additional information</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <InputDate v-model="inputs.sd_formatteDate" :is_view="is_view" label="Start date" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <TextArea v-model="inputs.sd_additionalShipmentDetail" label="Additional shipment detail" :is_view="is_view || isFromCost" divGridClass="col-sm-12"/>
                            </div>

                            <div class="col-md-6">
                                <InputDate v-model="inputs.sd_end_date" :is_view="is_view" label="End date" divGridClass="col-sm-12" />
                            </div>
                        </div>
                    </div>

                    <div class="section-block">
                        <div class="section-header">
                            <div>
                                <h3 class="section-title">Commercial Terms</h3>
                                <p class="section-sub">Payment, incoterms, label and pricing </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_payment_term" :is_view="is_view || isFromCost" :list="payment_term_list" label="Payment term" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_label" :is_view="is_view" :list="labelList" label="Label" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <SelectHttp v-model="inputs.sd_packer" :is_view="is_view" label="Packer name" :required="!toggle_validation" url="/packer/serverside/selectable-name" listValueField="value" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <TextArea v-model="inputs.label_description" label="Label description" :is_view="is_view" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <SelectHttp v-model="inputs.sd_broker" :is_view="is_view" label="Broker" url="/broker/serverside/selectable-name" listValueField="value" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6">
                                <InputNumber v-model="inputs.sd_commision" :is_view="is_view" label="Comission" divGridClass="col-sm-12"/>
                            </div>
                        </div> 

                        <div class="row">
                            <!-- Incoterm A -->
                            <div class="col-md-6">
                                <SelectCustom v-model="inputs.sd_incoterm" :is_view="is_view || isFromCost" :list="incotermList" label="Incoterm A" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 2">
                                <SelectCustom v-model="inputs.sd_incoterm_2" :is_view="is_view" :list="incotermList" label="Incoterm B" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>
   
                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 3">
                                <SelectCustom v-model="inputs.sd_incoterm_3" :is_view="is_view" :list="incotermList" label="Incoterm C" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>

                            <div class="col-md-6" v-if="inputs.sd_selectedOption >= 4">
                                <SelectCustom v-model="inputs.sd_incoterm_4" :is_view="is_view" :list="incotermList" label="Incoterm D" :required="!toggle_validation" divGridClass="col-sm-12" />
                            </div>
                        </div>
                    </div>

                    <div class="section-block">
                        <div class="section-header">
                            <div>
                                <h3 class="section-title">Conditions</h3>
                                <p class="section-sub">Manage and configure your general conditions</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <TextArea v-model="inputs.sd_specialDiscount" label="Special conditions" :is_view="is_view" divGridClass="col-sm-12" />
                            </div>
                            <div class="col-md-6"> 
                                <SelectHttp v-model="inputs.sd_supplier_condition" :is_view="is_view" label="Contract conditions" url="/contract_condition/serverside/selectable-name" listValueField="value" divGridClass="col-sm-12" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
					<div class="col-md-3">
						<button type="button" class="btn btn-primary mr-2 w-100" @click="redirectToCustomerDetail">
							{{ $t('continue') }}
						</button>
					</div>
				</div>
			</form>
		</div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import SelectCustom from '../components/SelectCustom.vue';
import SelectHttp from '../components/SelectHttp.vue';
import InputNumber from '../components/InputNumber.vue';
import TextArea from "../components/TextArea.vue";
import InputDate from '../components/InputDate.vue';
import AddressRequired from '../components/AddressRequired.vue';
import DescriptionAddress from '../components/DescriptionAddress.vue';
import {contactAddress, concatCompany, findObject, validateForm} from '../mixins/functions.js';
import {get_data_customTable, get_ship_address, get_data_supplier} from '../mixins/api.js';

export default {
    name: "products-detail",
    mixins: [FormMixin],
    components : {
        SelectCustom, SelectHttp, InputNumber, TextArea, InputDate, DescriptionAddress, AddressRequired,
	},
    data() {
        return {
            isFromCost : false,
            contractId : null, 
            preloader : false,
            from_to_list : [],
            ship_final_destination_list : [],
            payment_term_list : [],
            ship_address_list : [],
            incotermList : [],
            labelList : [],
            isLoading : false,
            toggle_validation : false,
            inputs: {
                sd_selectedOption:                  1,
                sd_ship :                           null,
                sd_supplier:                        { id : null, },
                sd_descriptionSupplier :            null,
                sd_ship_address :                   null,
                sd_descriptionSupplierShipAddress : null,
                sd_ship_address_2:                  null,
                sd_descriptionShipAddress2 :        null,
                sd_ship_address_3:                  null,
                sd_descriptionShipAddress3 :        null,
                sd_ship_address_4:                  null,
                sd_descriptionShipAddress4 :        null,
                sd_finalDest :                      null,
                sd_finalDestination :               null,
                sd_descriptionFinalDestination :    null,
                sd_formatteDate :                   null,
                sd_additionalShipmentDetail :       null,
                sd_end_date :                       null,
                sd_payment_term :                   null,
                sd_incoterm :                       null,
                sd_incoterm_2 :                     null,
                sd_incoterm_3 :                     null,
                sd_incoterm_4 :                     null,
                label_description :                 null,
                sd_label :                          null,
                sd_packer:                          {id : null },
                sd_broker:                          {id : null,},
                sd_commision :                      null,
                sd_supplier_condition :             {id: null},
                sd_specialDiscount :                null,
            },   
        }
    },
    computed: {
        is_view() {
            const is_view = localStorage.getItem('process_view_contract');
            if(is_view) return true;
            return false;
        },
    },
    methods: {
        async loadData(){
			this.preloader = true;
            this.isLoading = true;
            await Promise.all([
				this.fetchData('ship_from_to'),
				this.fetchData('payment_term'),
				this.fetchData('incoterm'),
				this.fetchData('label'),
            ]);
            this.ship_final_destination_list = [{id : 1, value : 'Ship To'}];
            const savedInputs = localStorage.getItem('DataSupplierDetail') !== 'undefined'
                                ? JSON.parse(localStorage.getItem('DataSupplierDetail')) 
                                : null;
            if (savedInputs) {    
                await this.set_inputs(savedInputs);
            }
            this.isLoading = false;
            this.preloader = false;
        },

        async fetchData(customTable) {
            const data = await get_data_customTable(customTable);
            if (customTable == 'ship_from_to') this.from_to_list = data; 
            else if (customTable == 'incoterm') this.incotermList = data; 
            else if (customTable == 'payment_term') this.payment_term_list = data;
            else if (customTable == 'label') this.labelList = data;
        },

        async set_inputs(savedInputs){
            if (savedInputs.sd_supplier) this.validateSupplier(savedInputs.sd_supplier);
            Object.keys(savedInputs).forEach(value => {
                this.inputs[value] = savedInputs[value];
            })
        },

        async fetchSupplierDetails(supplierId) { 
            const idSupplier = supplierId ? supplierId : this.inputs.sd_supplier.id;
            if (idSupplier) {
                this.ship_address_list = await get_ship_address(idSupplier); 
            }
			this.inputs.sd_descriptionSupplier = concatCompany(this.inputs.sd_supplier);  		 
        	const savedInputs = localStorage.getItem('DataSupplierDetail') ? JSON.parse(localStorage.getItem('DataSupplierDetail')) : null;

			if (savedInputs.sd_ship_address_2) {
				this.inputs.sd_ship_address_2 = savedInputs.sd_ship_address_2;
			}
            if (savedInputs.sd_ship_address_3) {
				this.inputs.sd_ship_address_3 = savedInputs.sd_ship_address_3;
			}
            if (savedInputs.sd_ship_address_4) {
				this.inputs.sd_ship_address_4 = savedInputs.sd_ship_address_4;
			}
            if (savedInputs.sd_finalDestination) {
				this.inputs.sd_finalDestination = savedInputs.sd_finalDestination;
			}
		},

        async redirectToCustomerDetail() {
			const validations = {
				sd_supplier: 'Supplier required',	
			}

			if (!this.toggle_validation) { // <- se agregan estas validaciones si no es el supplier to be confirmed
                validations.sd_ship = 'Ship from/to required',
				validations.sd_ship_address = 'Ship address required',
				validations.sd_payment_term = 'Payment term required';
                validations.sd_incoterm = 'Incoterm required';
				validations.sd_label = 'Label required';
				validations.sd_packer = 'Packer name required';
			}

			if (!validateForm(this.inputs, validations, this.$toastr)) {
				return;
			}

            if (this.inputs.sd_supplier.Title === 'Supplier to be confirmed') {
                await this.updateContractStatus();
            }

			this.redirected = true;
			this.$router.replace({
				name: "customer",
                query: { tab: "customer" },
                params: { id: this.contractId },
			});
		},

        async updateContractStatus() {
            // Obtener los status
            const statusDb = await get_data_customTable('status');
            const pendingStatus = statusDb.find( status => status.value === 'Pending');
            
            const dataContract = JSON.parse(localStorage.getItem('DataContractDetail'));
            if (pendingStatus) {
                dataContract.status = pendingStatus;
                localStorage.setItem('DataContractDetail', JSON.stringify(dataContract));
            } 
        },

        async loadSupplierDetails(id) {
            if (id) {
                const respuesta = await get_data_supplier(id);
                this.ship_address_list = await get_ship_address(respuesta.sd_supplier.id); 
                localStorage.setItem('DataSupplierDetail', JSON.stringify(respuesta));
            }
        },

        validateForm(inputs, validations) {
            for (const [field, message] of Object.entries(validations)) {  
                const value = field.split('.').reduce((o ,i) => o[i], inputs);
                if (!value) {            
                    this.$toastr.e(this.$t(message));
                    return false;
                }
                if (typeof value === 'object' && field != 'sd_formatteDate' && field != 'sd_end_date') {
                    if (!Object.values(value)[0]) {
                        this.$toastr.e(this.$t(message));
                        return false;
                    }   
                }
            }
            return true;
        },

        validateSupplier(supplier){
			if(supplier?.Title === 'Supplier to be confirmed'){
                this.toggle_validation = true;
				return;
			}
			this.toggle_validation = false;
		},

        updateInputs(newVal){
            for (let i = newVal + 1; i <= 4; i++) {
                this.inputs[`sd_ship_address_${i}`] = null;
                this.inputs[`sd_incoterm_${i}`] = null;
            }
        },
    },
    watch : {
        'inputs.sd_selectedOption'(newVal, oldVal){
            this.updateInputs(newVal);
        },  
        'inputs.sd_supplier.id'(newValue, oldValue) { // cuando cambien el supplier
            this.fetchSupplierDetails(newValue);
        },
        'inputs.sd_ship_address': {
            handler(newVal, oldValue) { 
                if (newVal) {
                    this.inputs.sd_descriptionSupplierShipAddress = contactAddress(newVal);
                }else {
                    this.inputs.sd_descriptionSupplierShipAddress = null;
                }
            },
            immediate: true // Para que se ejecute de inmediato en caso ya haya un valor
        },
        "inputs.sd_ship_address_2": {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.inputs.sd_descriptionShipAddress2 = contactAddress(newVal);
                }else{
                    this.inputs.sd_descriptionShipAddress2 = null;
                }
            },
            immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
        },
        "inputs.sd_ship_address_3": {
            handler(newVal, oldVal) {
                if (newVal) { 
                    this.inputs.sd_descriptionShipAddress3 = contactAddress(newVal);
                }else{
                    this.inputs.sd_descriptionShipAddress3 = null;
                }
            },
            immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
        },
        "inputs.sd_ship_address_4": {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.inputs.sd_descriptionShipAddress4 = contactAddress(newVal);
                }else{
                    this.inputs.sd_descriptionShipAddress4 = null;
                }
            },
            immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
        },
        "inputs.sd_finalDestination": {
			async handler(newVal, oldVal) {
                if (newVal) {
                    this.inputs.sd_descriptionFinalDestination = contactAddress(newVal);
                }else{
                    this.inputs.sd_descriptionFinalDestination = null;
                }
			},
			immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
		},
        inputs : {
            deep : true,
            handler(newVal){ // detecta los cambios de los inputs    
                if(this.isLoading) return;              
                localStorage.setItem('DataSupplierDetail', JSON.stringify(newVal));            
            }
        }
    }, 
    async mounted() {    
        this.contractId = this.$route.params.id;
        if (!this.contractId && !localStorage.getItem('DataSupplierDetail')) {
            this.contractId = JSON.parse(localStorage.getItem('DataContractDetail')).cd_contract_id;
        }
        if (this.contractId) {
            await this.loadSupplierDetails(this.contractId);
        }
        if (typeof localStorage.getItem('is_from_cost') !== 'undefined' && localStorage.getItem('is_from_cost')) {
            this.isFromCost = true;
        }
        this.loadData();
    },
}

</script>
